import React from 'react';
import JournalList from '../../components/doctors/JournalReview/JournalList';

/**
 * Patient Journal Entries page
 * A page that displays all journal entries for a doctor's patients
 */
const JournalEntries = () => {
  return (
        <JournalList />
  );
};

export default JournalEntries;